<template>
    <div>
        <p v-if="!editMode && dataType === 'date'" class="pa-0 ma-0">{{ content | dateConvert }} <v-icon class="ml-4 hoverRed" small @click="editContent" title="Редактировать">mdi-pencil</v-icon></p>
        <p v-else-if="!editMode && dataType !== 'date'" class="pa-0 ma-0">{{ content }} <v-icon class="ml-4 hoverRed" small @click="editContent" title="Редактировать">mdi-pencil</v-icon></p>
        <div v-if="!!editMode">
            <v-text-field :type="dataType" ref="editorfield" dense @input="handleInput" v-model="content" @change="change" append-icon="mdi-check" @click:append="change"></v-text-field>
        </div>
    </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'answerPlace',
    props: ['value', 'type'],
    data () {
      return {
        editMode: false,
        content: this.value,
        dataType: this.type ? this.type : 'text'
      }
    },
    filters: {
      dateConvert: function (value) {
        return moment(value).format('YYYY-MM-DD')
      }
    },
    methods: {
      change() {
        this.editMode = false
        this.$emit('input', this.content)
        this.$nextTick(function () {
          this.$emit('change')
        })
      },
      editContent() {
        this.editMode = true
        this.$nextTick(() => {
          this.$refs.editorfield.focus()
        })
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
    .hoverRed:hover {
        color: dodgerblue;
    }
</style>